import { trackCompletedOrder } from "@insite/client-framework/Common/Utilities/tracking";
import {
    addToChainAfter,
    addToEndOfChain,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { Cart, updateCartWithResult } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain,
    ExecuteOnSuccessCallback,
    SendTracking,
    SetCreditCard,
    UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { checkoutOption, dispatchCheckoutEvent, dispatchPurchaseEvent } from "@store/Services/AnalyticsService";
import StoreApplicationState from "@store/Store/StoreApplicationState";

replaceInChain(chain, UpdateCart, async props => {
    /* Poolcorp Custom Code */
    const deliveryTrackingPhoneNumber = (props.getState() as StoreApplicationState).store.pages.checkoutReviewAndSubmit.deliveryTrackingPhoneNumber;
    const deliveryTrackingPhoneNumberValidOrEmpty = (props.getState() as StoreApplicationState).store.pages.checkoutReviewAndSubmit.deliveryTrackingPhoneNumberValidOrEmpty;

    if (deliveryTrackingPhoneNumber && deliveryTrackingPhoneNumberValidOrEmpty) {
        props.cartToUpdate.properties.deliveryTrackingPhoneNumber = deliveryTrackingPhoneNumber;
    }
    const isPaymentMethodCardOnFile =
        props.cartToUpdate.paymentMethod?.name === props.cartToUpdate.properties.cardOnFilePaymentKey
        && props.cartToUpdate.properties.cardOnFilePaymentKey !== "";
    if (!isPaymentMethodCardOnFile && props.cartToUpdate.properties.creditCardOnFileToken) {
        props.cartToUpdate = {
            ...props.cartToUpdate,
            properties: {
                ...props.cartToUpdate.properties,
                creditCardOnFileToken: "",
            },
        };
    }

    let result: any;

    try {
        result = await updateCartWithResult(props.apiParameter);
    } catch (error) {
        result = {
            successful: false,
            errorMessage: (error as any).errorMessage || siteMessage("ERP_Order_Failed_Message"),
        };
    }

    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    /* Poolcorp Custom Code */

    if (result.successful) {
        props.apiResult = result.result;
        /* Poolcorp Custom Code */
        if (cart) {
            props.dispatch({
                type: "Data/Carts/CompleteLoadCart",
                model: {...cart, erpOrderNumber: props.apiResult.cart.erpOrderNumber, poNumber: props.apiResult.cart.poNumber},
            });
        }
        /* Poolcorp Custom Code */
        props.dispatch({
            type: "Data/Carts/ResetCart",
            id: props.apiParameter.cart.id,
        });
    } else {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
        props.dispatch({
            type: "Pages/CheckoutReviewAndSubmit/FailedToPlaceOrder",
            errorMessage: result.errorMessage,
        });
        return false;
    }
});

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult?.cart?.id);
    dispatchCheckoutEvent(3, checkoutOption.orderConfirmation, props.cartToUpdate); // Poolcorp Custom Code
});

replaceInChain(chain, SendTracking, props => {
    const updatedCart = { ...props.cartToUpdate, orderNumber: props.apiResult.cart.orderNumber };
    const session = getSession(props.getState());
    trackCompletedOrder(updatedCart, props.apiResult.billTo, session);
    dispatchPurchaseEvent(updatedCart); // Poolcorp Custom Code
});

/* Poolcorp Custom Code */
addToChainAfter(chain, SetCreditCard, props => {
    if (props.parameter.isAdyenDropIn) {
        const { cartToUpdate } = props;

        const cardNumberData = JSON.parse(props.parameter.cardNumber); // Poolcorp Custom Code

        cartToUpdate.properties = {
            ...cartToUpdate.properties,
            adyenCardNumber: `${cardNumberData.cardBin}****${cardNumberData.cardSummary}`, // Poolcorp Custom Code
            adyenCardExpirationDate: cardNumberData.cardExpirationDate, // Poolcorp Custom Code
            adyenCardType: props.parameter.cardType,
            adyenRecurringDetailReference: props.parameter.payPalToken || "",
            adyenCardSchemeEnhancedDataLevel: cardNumberData.cardSchemeEnhancedDataLevel, // Poolcorp Custom Code
            avsResult: cardNumberData.avsResult, // Poolcorp Custom Code
        };
    }
});

addToEndOfChain(chain, props => {
    window.localStorage.removeItem("order-po-number");
});
/* Poolcorp Custom Code */
